import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '../providers/AuthContext.js';

/**
 * API function to get current user's session data
 */
const getMe = async (apiClient, endpoint) => {
    const response = await apiClient.get(endpoint);
    return response.data;
};
/**
 * Hook for fetching current user's session data (GET /me)
 * Errors (401/403) will be handled by AuthSessionProvider
 *
 * @param enabled - Controls whether the query should run. Should be set to true
 *                  only when firebaseUser exists. Controlled by AuthSessionProvider.
 * @param endpoint - Backend endpoint for GET /me (e.g., '/admin_portal/auth/me')
 * @param apiClient - Optional API client. If not provided, will use context.
 * @param queryKeys - Optional query keys. If not provided, will use context.
 */
const useGetMe = (enabled = false, endpoint, apiClient, queryKeys) => {
    // If apiClient and queryKeys are provided, use them directly (for AuthSessionProvider)
    // Otherwise, get them from context (for components using this hook)
    if (apiClient && queryKeys) {
        return useQuery({
            queryKey: queryKeys.me,
            queryFn: () => getMe(apiClient, endpoint),
            enabled,
            staleTime: Infinity, // Session data doesn't change during a session
            retry: 1, // Retry once on failure
        });
    }
    // Fall back to context for components
    const { apiClient: contextApiClient, queryKeys: contextQueryKeys } = useAuthContext();
    return useQuery({
        queryKey: contextQueryKeys.me,
        queryFn: () => getMe(contextApiClient, endpoint),
        enabled,
        staleTime: Infinity, // Session data doesn't change during a session
        retry: 1, // Retry once on failure
    });
};

export { getMe, useGetMe };
//# sourceMappingURL=useGetMe.js.map
